// extracted by mini-css-extract-plugin
module.exports = {"Droppable":"Droppable_Droppable__3jrVK","dragging":"Droppable_dragging__2c-yZ","over":"Droppable_over__OZ_dA","dropped":"Droppable_dropped__i49CD"};